import type { RankingRewardSlice } from "@/types/RankingRewardSlice";
import { RankingRewardsRow } from "./RankingRewardsRow";
interface RankingRewardsTableProps {
  rankingRewardSlices: RankingRewardSlice[];
}

export const RankingRewardsTable = ({ rankingRewardSlices }: RankingRewardsTableProps) => {
  return (
    <div data-orientation="vertical">
      {/* Header Row */}
      <div className="flex items-center mt-[16.5px] mb-[17.5px] gap-[6px] mx-5">
        <div className="w-1/3" />
        <div className="flex-1">
          <div className="text-dark-gray text-center text-[12px] font-medium leading-[145.3%]">現在のボーダー</div>
        </div>
        <div className="flex-1">
          <div className="text-dark-gray text-center text-[12px] font-medium leading-[145.3%]">報酬</div>
        </div>
      </div>

      {/* User Rows */}
      <div className="mx-5 rounded-lg overflow-hidden flex flex-col gap-1 h-[60vh] overflow-y-auto">
        {rankingRewardSlices.map((rankingRewardSlice, index) => {
          return <RankingRewardsRow rankingRewardSlice={rankingRewardSlice} key={index} />;
        })}
      </div>
    </div>
  );
};
